const MAX_INFINITE_PRODUCTS = 50;

function initInfiniteScroll() {

  const productList = document.querySelector('product-list');
if (!productList) return;

// Respect theme editor toggle
if (productList.dataset.infiniteScrollEnabled !== 'true') return;

if (productList.dataset.infiniteScroll === 'active') return;
productList.dataset.infiniteScroll = 'active';

  let loadedCount = productList.querySelectorAll(':scope > *').length;

  function getNextPageUrl() {
    const nextLink = document.querySelector('.pagination__item[rel="next"]');
    return nextLink ? nextLink.href : null;
  }

  function showPagination() {
    const pagination = document.querySelector('.collection__pagination, .pagination');
    if (pagination) {
      pagination.style.display = '';
    }
  }

  function hidePagination() {
    const pagination = document.querySelector('.collection__pagination, .pagination');
    if (pagination) {
      pagination.style.display = 'none';
    }
  }

  let isLoading = false;
  let observer;

  function appendProducts(html) {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');
    const newProducts = newDoc.querySelectorAll('product-list > *');
    const newPagination = document.querySelector('.collection__pagination, .pagination');
    const newPaginationContent = newDoc.querySelector('.collection__pagination, .pagination');

    newProducts.forEach(function (product) {
      productList.appendChild(product);
      loadedCount++;
    });

    if (newPagination && newPaginationContent) {
      newPagination.innerHTML = newPaginationContent.innerHTML;
    } else if (newPagination) {
      newPagination.remove();
    }

    isLoading = false;

    if (loadedCount >= MAX_INFINITE_PRODUCTS) {
      // Stop infinite scroll and show pagination buttons
      if (observer) observer.disconnect();
      removeSentinel();
      showPagination();
      return;
    }

    if (getNextPageUrl()) {
      hidePagination();
      observeSentinel();
    } else {
      if (observer) observer.disconnect();
      removeSentinel();
      showPagination();
    }
  }

  function loadNextPage() {
    const nextUrl = getNextPageUrl();
    if (!nextUrl || isLoading) return;
    isLoading = true;

    fetch(nextUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) { appendProducts(html); })
      .catch(function () {
        isLoading = false;
        showPagination();
      });
  }

  function removeSentinel() {
    const sentinel = document.getElementById('infinite-scroll-sentinel');
    if (sentinel) sentinel.remove();
  }

  function observeSentinel() {
    let sentinel = document.getElementById('infinite-scroll-sentinel');
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.id = 'infinite-scroll-sentinel';
      sentinel.style.height = '1px';
      productList.parentNode.insertBefore(sentinel, productList.nextSibling);
    }

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '1000px' });

    observer.observe(sentinel);
  }

  removeSentinel();

  if (loadedCount < MAX_INFINITE_PRODUCTS && getNextPageUrl()) {
    hidePagination();
    observeSentinel();
  }
}

// Run on initial page load
initInfiniteScroll();

// Re-run after AJAX collection swap
const bodyObserver = new MutationObserver(function (mutations) {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && (node.tagName === 'PRODUCT-LIST' || node.querySelector('product-list'))) {
        initInfiniteScroll();
        return;
      }
    }
  }
});

bodyObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Scroll to top of collection on AJAX navigation
const collectionSection = document.querySelector('.shopify-section--main-collection, [id*="main-collection"]');

const scrollObserver = new MutationObserver(function (mutations) {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && (node.tagName === 'PRODUCT-LIST' || node.querySelector('product-list'))) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
    }
  }
});

if (collectionSection) {
  scrollObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

